import { INamespaceTranslationKeyMap } from '@nicejob-library/internationalization/types';

/**
 * It is separated from DefaultNpsSurveyQuestionId because
 * in future we might want to support custom questions with UUID
 * as IDs.
 */
export enum NpsSurveyQuestionTranslationKey {
    ServicePerformance = 'service_performance',
    Pricing = 'pricing',
    SchedulingCommunication = 'scheduling_communication',
    Professionalism = 'professionalism',
    Retention = 'retention',
}

/**
 * Default NPS survey question IDs
 * These are the unique identifiers for each default question.
 * Currently they match the translation keys, but can be UUIDs in the future.
 *
 * @note The question ID is the value of the enum.
 * @note The question ID must be unique and never exist before.
 * Please check database to ensure.
 */
export enum DefaultNpsSurveyQuestionId {
    ServicePerformance = 'service_performance',
    Pricing = 'pricing',
    SchedulingCommunication = 'scheduling_communication',
    Professionalism = 'professionalism',
    Retention = 'retention',
}

/**
 * i18n label keys (insights namespace) for each default question.
 * Used by formatNpsCampaignQuestionBreakdown to translate question labels.
 *
 * @note Update DEFAULT_NPS_SURVEY_QUESTIONS as well
 */
export const NPS_SURVEY_QUESTION_LABEL_KEYS: Record<
    string,
    INamespaceTranslationKeyMap<'insights'>
> = {
    [DefaultNpsSurveyQuestionId.ServicePerformance]:
        'feedback_routing.survey_insights.question.service_performance',
    [DefaultNpsSurveyQuestionId.Pricing]: 'feedback_routing.survey_insights.question.pricing',
    [DefaultNpsSurveyQuestionId.SchedulingCommunication]:
        'feedback_routing.survey_insights.question.scheduling_communication',
    [DefaultNpsSurveyQuestionId.Professionalism]:
        'feedback_routing.survey_insights.question.professionalism',
    [DefaultNpsSurveyQuestionId.Retention]: 'feedback_routing.survey_insights.question.retention',
};

/**
 * Default NPS survey question definition (without translated text)
 */
export interface INpsSurveyQuestionDefinition {
    default_survey_question_id: DefaultNpsSurveyQuestionId;
    translation_key: NpsSurveyQuestionTranslationKey;
    required: boolean;
}

/**
 * Default NPS survey questions configuration
 */
export const DEFAULT_NPS_SURVEY_QUESTIONS: INpsSurveyQuestionDefinition[] = [
    {
        default_survey_question_id: DefaultNpsSurveyQuestionId.ServicePerformance,
        translation_key: NpsSurveyQuestionTranslationKey.ServicePerformance,
        required: false,
    },
    {
        default_survey_question_id: DefaultNpsSurveyQuestionId.Pricing,
        translation_key: NpsSurveyQuestionTranslationKey.Pricing,
        required: false,
    },
    {
        default_survey_question_id: DefaultNpsSurveyQuestionId.SchedulingCommunication,
        translation_key: NpsSurveyQuestionTranslationKey.SchedulingCommunication,
        required: false,
    },
    {
        default_survey_question_id: DefaultNpsSurveyQuestionId.Professionalism,
        translation_key: NpsSurveyQuestionTranslationKey.Professionalism,
        required: false,
    },
    {
        default_survey_question_id: DefaultNpsSurveyQuestionId.Retention,
        translation_key: NpsSurveyQuestionTranslationKey.Retention,
        required: false,
    },
];
